import {createFeatureSelector, createSelector} from '@ngrx/store';
import {State} from './production-instance.stop-many.reducer';

export const stopManyProductionInstancesFeatureKey = 'stopManyProductionInstances';
export const featureSelector = createFeatureSelector<State>(stopManyProductionInstancesFeatureKey);

export const getStopManyProductionInstancesRecord = createSelector(
  featureSelector,
  (state: State): null => state.record
);

export const getStopManyProductionInstancesLoaded = createSelector(
  featureSelector,
  (state: State): boolean => state.loaded
);

export const getStopManyProductionInstancesLoading = createSelector(
  featureSelector,
  (state: State): boolean => state.loading
);

export const getStopManyProductionInstancesError = createSelector(
  featureSelector,
  (state: State): any => state.error
);
